<template>
    <div>
        <outstandingsSummaryCustomer v-show="tab == 'customer'" ref="outstandingsSummaryCustomer" @setBalanceSummary="setBalanceSummary" @setExportData="setExportData"></outstandingsSummaryCustomer>
        <outstandingsSummaryDate v-show="tab == 'date'" ref="outstandingsSummaryDate" @setSummary="setSummary" @setExportData="setExportData"></outstandingsSummaryDate>
    </div>
</template>
<script>
import OutstandingsSummaryDate from './Outstandings_Summary_Date'
import OutstandingsSummaryCustomer from './Outstandings_Summary_Customer'
export default {
    name: "outstandingsSummary",
    data(){
        return{
            tab: "customer",
        }
    },
    components:{
        OutstandingsSummaryDate, OutstandingsSummaryCustomer
    },
    methods:{
        async handleCreditSummary(filterObj){
            this.tab = filterObj.summaryType
            if(this.tab == 'date'){
                this.$refs.outstandingsSummaryDate.setCreditSummary(filterObj);
            }else{
                await this.$refs.outstandingsSummaryCustomer.setCreditSummaryCustomer(filterObj);
            }
        }, 
        setSummary(data){
            this.$emit('setSummary', data)
        },
        setBalanceSummary(total){
            this.$emit('setBalanceSummary', total)
        },
        setExportData(data){
            this.$emit('setExportData', data)
        }
    }
}
</script>
